export const addFolderField = {
    id: 'name',
    name: 'name',
    placeholder: '',
    type: 'text',
    label: {
        htmlFor: 'name',
        value: 'Podaj nazwę:'
    }
};